module.exports = __webpack_public_path__ + "static/img/sec4-cont-txt02@t.f4a79c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-history/sec4-cont-txt02@t.png
// module id = C4Zn
// module chunks = 0